module.exports = __webpack_public_path__ + "static/media/require-upgrade-standard-search.3f533dfc.png";